module.exports = __webpack_public_path__ + "Roboto-Light.183079184d96a491f16e.eot";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Light.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Light.eot
// module chunks = styles